import i18n from '@/plugins/vuei18n'

export default [
    {
        id: "new",
        label: i18n.t('order.status.new')
    },
    {
        id: "canceled",
        label: i18n.t('order.status.canceled')
    },
    {
        id: "reserved",
        label: i18n.t('order.status.reserved')
    },
    {
        id: "realized",
        label: i18n.t('order.status.realized')
    }
]
